module.exports = __webpack_public_path__ + "media/images/flags/sl-4fd17d63688a1b300bcafac703d5dd7c.svg";